var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.656876 17.9994L20.5828 17.9994M2.14256 6.25885L19.1011 6.25885L2.14256 6.25885ZM18.9078 4.90603L10.654 0.457031L2.33582 4.90603L18.9078 4.90603ZM2.5935 14.8388L18.6461 14.8388L2.5935 14.8388ZM1.68759 16.3849L19.552 16.3849L1.68759 16.3849Z",
    stroke: "#8A94A6",
    strokeWidth: 0.838264,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75252 6.32324L3.75252 14.8387M5.81396 6.32324L5.81395 14.8387M9.4255 6.32324L9.4255 14.8387M11.491 6.32324L11.491 14.8387M15.1025 6.32324L15.1025 14.8387M17.1639 6.32324L17.1639 14.8387",
    stroke: "#8A94A6",
    strokeWidth: 0.838264,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIconGrey);
export default __webpack_public_path__ + "static/media/bank-icon-grey.16180613f6d5d2dfa9b8b497bdc59dc0.svg";
export { ForwardRef as ReactComponent };